import styled from "styled-components";
import { setFlex, setPosition } from "../variables/utils";

export const LandingWrapper = styled.div`
  ${setPosition({ position: "relative", zIndex: "0" })};
  min-height: 100vh;
  width: 100%;
  &.active {
    z-index: 2;
  }
`;

export const LandingContainer = styled.div`
  min-height: 200vh;
  width: 100%;
`;

export const Wrapper = styled.div`
  ${setPosition({ position: "relative" })};
  width: 100%;
`;

export const Container = styled.div`
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  width: 100%;
`;

export const HeroImage = styled.img`
  width: 100%;
  height: auto;
`;

export const Headline = styled.h1`
  ${setPosition({ position: "absolute", top: "0" })};
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  height: 100vh;
  font-size: 2rem;
  font-family: univers-roman;
`;

export const Paragraph = styled.p`
  font-family: univers-light;
`;
